export const groupByValueOfKey = <T, K extends keyof T>(array: T[], key: K) =>
    array.reduce(
        (grouped, item) => ({
            ...grouped,
            [item[key] as any]: [...(grouped[item[key] as any] ?? []), item],
        }),
        {} as { [value: string]: T[] }
    );

export const isStringArrayWithEntries = (input: any): input is string[] =>
    Array.isArray(input) && input.length > 0 && input.every((entry) => typeof entry === 'string');
